import * as React from 'react';
import {
    Show,
    TextInput,
    useTranslate,
    useRecordContext,
    required,
    SelectInput,
    ReferenceInput,
    Create,
    TabbedShowLayout,
    TextField,
    ReferenceField,
    DateTimeInput,
    NumberField,
    Pagination,
    Datagrid,
    ReferenceManyField,
    SimpleForm,
    useRefresh,
    RichTextField,
    useGetList,
    Edit,
    SimpleShowLayout,
    AutocompleteInput,
    minValue,
    DateInput,
    DateField,
    useDataProvider,
    useNotify,
    useCreate,
    FunctionField,
    FormDataConsumer,
    DataProviderContext,
} from 'react-admin';

import ThumbnailField from '../../common/ThumbnailField';
import FullNameField from '../../common/FullNameField';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { ChatBubble, CopyAll, Edit as EditIcon, Today, Visibility } from '@mui/icons-material';

import { QUESTION_TYPES, VIDEO_TYPES } from '../../common/constants';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { LinearProgress, Typography } from '@mui/material';
import { NoDataSection } from '../../common/NoDataSection';
import { useNavigate, useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { EditToolbar } from '../../common/EditToolbar';
import { Subjects, Users } from '../../custom';
import { SoftDeleteWithDialogAction } from '../../common/SoftDeleteWithDialogAction';
import { addDays, format } from 'date-fns';
import { displayPrice } from '../../common/string-utilities';
import OrderField from '../../common/OrderField';
import TotalAmountInput from '../../common/inputs/TotalAmountInput';
import DiscountInput from '../../common/DiscountInput';
import { createCustomGoDataProvider } from '../../services';
import AssignEcomProductModal from '../../common/ecom-products/AssignEcomProductModal';
import AssignedUserList from '../../common/ecom-products/AssignedUserList';
import { useAssignRefresh } from '../../hooks/useAssignRefresh';
import AssignedEcomProductList from '../../common/ecom-products/AssignedEcomProductList';

export const EndsOnTime = (props: any) => {
    const record = useRecordContext<any>();
    const isExpired = new Date(record.ends_on) < new Date() && record.ends_on;
    return record ? (
        <div
            className={'flex flex-col text-sm space-y-1'}
            style={{ background: isExpired ? 'red' : 'transparent' }}
        >
            {record.ends_on && (
                <div className={'flex items-center space-x-2'}>
                    <div className={'whitespace-nowrap'}>
                        {format(new Date(record.ends_on), 'dd-MMM-yyyy hh:mm a')}
                    </div>
                </div>
            )}
        </div>
    ) : null;
};

EndsOnTime.defaultProps = {
    source: 'ends_on',
    label: 'Ends On',
};
const SubjectShow = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [studentQuery, setStudentQuery] = useState('');
    const { refreshKey, handleAssignSuccess } = useAssignRefresh();

    const handleTabClick = (index: any) => {
        setActiveTab(index);
    };
    let { subjectId, mode } = useParams();
    const baseDataProvider = useDataProvider();
    if (!subjectId) {
        return <LoadingSection />;
    }
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'subjects', apiEndpoint: `/subjects` },
            ]),
        [baseDataProvider],
    );

    const tabData = [
        {
            label: 'Details',
            content: (
                <div>
                    <DataProviderContext.Provider value={customDataProvider}>
                        <Show title={<Title />} resource={'subjects'} id={subjectId}>
                            <SimpleShowLayout>
                                <ThumbnailField size={'large'} source="image" />
                                <TextField source="name" fullWidth />
                                <RichTextField source="description" />
                                <TextField source="displayOrder" fullWidth />
                                <TextField source="exercisesCount" fullWidth />
                                <TextField source="homeworksCount" fullWidth />
                                <TextField source="lecturesCount" fullWidth />
                                <TextField source="notesCount" fullWidth />
                                <TextField source="programStatus" fullWidth />
                                <TextField source="slug" fullWidth />
                                <TextField source="status" fullWidth />
                                <TextField source="totalExercises" fullWidth />
                                <TextField source="totalLectureDurationsInSeconds" fullWidth />
                                <TextField source="totalNotes" fullWidth />
                                <TextField source="totalVideos" fullWidth />
                                <TextField source="videosCount" fullWidth />
                            </SimpleShowLayout>
                        </Show>
                    </DataProviderContext.Provider>
                </div>
            ),
        },

        {
            label: 'Product Details',
            content: (
                <Show id={subjectId} title={' '} resource={'subjects'}>
                    <SimpleShowLayout>
                        <AssignedEcomProductList
                            type="subject"
                            typeId={subjectId}
                            refreshKey={refreshKey}
                        />
                    </SimpleShowLayout>
                </Show>
            ),
        },

        {
            label: 'Students',
            content: (
                <div>
                    <AssignedUserList type="subjects" typeId={subjectId} refreshKey={refreshKey} />
                </div>
            ),
        },
    ];

    return (
        <>
            <div className="flex justify-end mr-10 pt-5 pb-2">
                <AssignEcomProductModal
                    type="subject"
                    typeId={subjectId}
                    title="Assign Subject"
                    onSuccess={handleAssignSuccess}
                />
            </div>
            <div className="  border rounded-md mb-14">
                <div className=" border-collapse flex text-lg felx-row gap-16 px-10 pt-4 ">
                    {tabData.map((tab, index) => (
                        <div
                            key={index}
                            onClick={() => handleTabClick(index)}
                            className={`tab ${
                                index === activeTab
                                    ? 'active text-[#4f3cc9]  underline decoration-4 underline-offset-[20px]'
                                    : ''
                            }`}
                        >
                            {tab.label}
                        </div>
                    ))}
                </div>
                <div className="tab-content">{tabData[activeTab].content}</div>
            </div>
        </>
    );
};

const Title = () => {
    const record = useRecordContext<Subjects>();

    return record ? <span className="capitalize">{record.name}</span> : null;
};

export default SubjectShow;
